/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_Agents_CcInputs */

const en_cad_compare_row_agents_cc = /** @type {(inputs: Cad_Compare_Row_Agents_CcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built in: MCP, JSON control, headless CLI`)
};

/**
* | output |
* | --- |
* | "Built in: MCP, JSON control, headless CLI" |
*
* @param {Cad_Compare_Row_Agents_CcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_agents_cc = /** @type {((inputs?: Cad_Compare_Row_Agents_CcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_Agents_CcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_agents_cc(inputs)
});
export { cad_compare_row_agents_cc as "cad.compare.row_agents_cc" }